import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import moment from "moment";
import TrainingCmeService from "services/Training/TrainingCmeService";

export const SearchTrainingCmeApi = createAsyncThunk(
  "trainingCme/SearchTrainingCmeApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await TrainingCmeService.search(data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const SearchTrainingCmeTrackingApi = createAsyncThunk(
  "trainingCme/SearchTrainingCmeTrackingApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await TrainingCmeService.searchTracking(data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetTrainingCmeThietLapKyTheoDoi = createAsyncThunk(
  "trainingCme/GetTrainingCmeThietLapKyTheoDoi",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await TrainingCmeService.getTrainingCmeThietLapKyTheoDoi();
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetTrainingCmeByIdApi = createAsyncThunk(
  "trainingCme/GetTrainingCmeByIdApi",
  async (id, { rejectWithValue }) => {
    try {
      const response = await TrainingCmeService.getById(id);
      response.data.time = [
        moment(response.data.startDate),
        moment(response.data.endDate),
      ];
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpSertTrainingCmeApi = createAsyncThunk(
  "trainingCme/UpSertTrainingCmeApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await TrainingCmeService.upSert(payload);
      if (onSuccess) onSuccess(response.data.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  list: [],
  detail: {},
  kyTheoDoi: [],
};

const trainingCmeSlice = createSlice({
  name: "trainingCme",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SearchTrainingCmeApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(SearchTrainingCmeApi.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(SearchTrainingCmeApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(SearchTrainingCmeTrackingApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(SearchTrainingCmeTrackingApi.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(SearchTrainingCmeTrackingApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(GetTrainingCmeThietLapKyTheoDoi.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetTrainingCmeThietLapKyTheoDoi.fulfilled, (state, action) => {
        state.loading = false;
        state.kyTheoDoi = action.payload;
      })
      .addCase(GetTrainingCmeThietLapKyTheoDoi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(GetTrainingCmeByIdApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetTrainingCmeByIdApi.fulfilled, (state, action) => {
        state.loading = false;
        state.detail = action.payload;
      })
      .addCase(GetTrainingCmeByIdApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(UpSertTrainingCmeApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpSertTrainingCmeApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertTrainingCmeApi.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default trainingCmeSlice.reducer;
